module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w98"
  }, [_c('div', {
    staticClass: "crumb"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/Help"
    }
  }, [_vm._v("帮助")]), _vm._v("  > ")], 1), _vm._v(" "), _c('span', [_vm._v("专题读片")])]), _vm._v(" "), _c('help-Menu'), _vm._v(" "), _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "conten"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', [_c('template', {
    slot: "title"
  }, [_vm._v("\n                 专题读片\n            ")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("用户在此可进行专题会议的新建。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("步骤一：用户点击【新增会议】，在专题会议新增界面，完善基本信息的输入，点击【保存待发】，会议即可保存成功。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("步骤二：选择“会议类型”，设置密码。类型为“公开”时，可设置密码，也可不设置6位数字密码。类型为“私密”时，不设置密码，但需选择开放范围。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("步骤三：添加影像、病历、附件。")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/41.png")
    }
  })])], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "会议编辑"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("功能只对会议主持人开放。当“发送状态”为“保存待发”时，点击"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/80.png")
    }
  })]), _vm._v("，可进入编辑页面进行编辑，完成编辑后，点击：")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("一．保存待发，保存后，状态不变")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("二．发送，保存后，会议发送状态为“已发送”")])], 1), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "会议发送及撤回"
    }
  }, [_c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("发送")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("方法一：选择“保存待发”记录，进入编辑详情页面，点击【发送】")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("方法二：勾选 “保存待发”记录，点击发送"), _c('b', [_c('img', {
    staticClass: "ltImg",
    attrs: {
      "src": require("../../../../static/image/81.png")
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("批量发送")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("勾选 “保存待发”记录，点击发送"), _c('b', [_c('img', {
    staticClass: "ltImg",
    attrs: {
      "src": require("../../../../static/image/81.png")
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("撤回")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("只有“发送状态”为“已发送”，并且“会议状态”为“未开始”会议，可以使用撤回功能。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("会议主持人选择需撤回记录 ，点击"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/87.png")
    }
  })]), _vm._v("，确认后，发送状态即可变为“保存待发”（非主持人无此权限）。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("会议隐藏")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("批量勾选记录，点击"), _c('b', [_c('img', {
    staticClass: "ltImg",
    attrs: {
      "src": require("../../../../static/image/82.png")
    }
  })]), _vm._v(" ，确认后，所选记录将从列表中除去。此操作不可撤销。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("会议查看")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("用户点击"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/78.png")
    }
  })]), _vm._v("，即可进入查看会议详情。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("如会议设置密码，则需先输入密码。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("会议开启")]), _vm._v(" "), _c('h3', {
    staticClass: "text"
  }, [_vm._v("正常开启:“发送状态”为“已发送”的专题会议， 当会议开始时间到达时，“会议状态”会自动切换为“进行中”，即自动开启。")]), _vm._v(" "), _c('h3', {
    staticClass: "text"
  }, [_vm._v("提前开启：会议主持人可提前半小时，点击，提前开始会议，此时“会议状态”将提前切换为“进行中”。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("已结束的会议，如存在会议视频，参会人员可点击【回放录播】，进行视频回放。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("会议进入")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("参会人员在“会议状态”变为“进行中”后，可通过点击"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/88.png")
    }
  })]), _vm._v("，进入会议。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("会议结束")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("会议主持人在进入会议后，点击【结束会议】，即可关闭当前会议。参会人员无权限关闭会议。若主持人忘记结束会议，会议会在每日凌晨自动结束。")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3e51239d","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/DailyReading/ThematicReading.vue
// module id = 557
// module chunks = 1 2 3 4 5 6 7 8